import moment from 'moment';
const DayJS = require('dayjs');
const DayDuration = require('dayjs/plugin/duration');
DayJS.extend(DayDuration);

import { Timespan } from 'constants/constants';

export const dayjs = DayJS;

export const last30Days = () => {
  return [
    moment().subtract(30, 'days').valueOf(),
    Date.now(),
  ];
}


export const shortTimeAgo = timestamp => {
  let diff = moment.duration(moment().diff(moment(timestamp)));
  let s = '';
  let time = {
    days: diff.days(),
    hours: diff.hours(),
    minutes: diff.minutes(),
  }
  if(diff.days() > 0)
    s = s + diff.days() + 'd ';
  if(diff.hours() > 0)
    s = s + diff.hours() + 'h ';
  if(diff.days() === 0)
    s = s + diff.minutes() + 'm ';

  return s.trim();
}

export const formatDate = date => {
  return moment(date).format("MM/DD/YY")
}

export const toNow = ts => (moment(ts).valueOf() - Date.now())

export const clientTimezone = () => Intl.DateTimeFormat().resolvedOptions().timeZone;

export const rangeToString = (range, dates) => {
  switch(range) {
    case Timespan.MONTH:
      return 'This Month';
    case Timespan.PREV_MONTH:
      return 'Previous Month';
    case Timespan.WEEK:
      return 'This Week';
    case Timespan.PREV_WEEK:
      return 'Previous Week';
    case Timespan.DAYS_30:
      return 'Last 30 Days';
    case Timespan.DAYS_7:
      return 'Last 7 Days';
    case Timespan.HOURS_24:
      return 'Last 24 Hours';
    case 'custom':
      let s = moment(dates.from).format("M/D/YY");
      let e = moment(dates.to).format("M/D/YY");
      return `${s} - ${e}`;
  }
}